import React, { useEffect, useState, useContext, FC } from 'react';

import { Button } from '@grupoboticario/flora-react';

import Styled from './PageSelectorStyled';

import sendChangePageEvent from 'src/services/googleAnalytics/helpers/changePage/sendChangePageEvent';

import { CatalogContext, actions } from 'src/contexts/Catalog';

interface IPageSelector {
  buttonVariant?: 'conversion' | 'ghost';
  hideSelector?: () => void;
}

const PageSelector: FC<IPageSelector> = ({
  buttonVariant = 'ghost',
  hideSelector,
}) => {
  const [state, dispatch] = useContext(CatalogContext);
  const [selectValue, setSelectValue] = useState(state.page.toString());

  const handleSelectChange = (
    event: React.ChangeEvent<HTMLSelectElement>,
  ): void => {
    setSelectValue(event.target.value);
  };

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>): void => {
    event.preventDefault();

    dispatch(actions.goToPage(+selectValue));
    sendChangePageEvent.buttonClick(+selectValue);

    hideSelector && hideSelector();
  };

  useEffect(() => setSelectValue(state.page.toString()), [state.page]);

  return (
    <Styled.Form onSubmit={handleSubmit}>
      <Styled.SelectLabel id="page-selector-label">
        Selecionar página
      </Styled.SelectLabel>
      <Styled.SelectWrapper>
        <span>{`${selectValue} de ${state.numberOfPages}`}</span>
        <Styled.Select
          aria-labelledby="page-selector-label"
          data-testid="PageSelector-select"
          value={selectValue}
          onChange={handleSelectChange}
        >
          {state.catalogData?.pages?.map((page) => {
            return (
              <option key={page.number} value={page.number}>
                {page.number}
              </option>
            );
          })}
        </Styled.Select>
      </Styled.SelectWrapper>

      <Button
        data-testid="PageSelector-submit-button"
        type="submit"
        variant={buttonVariant}
        aria-label={`Ir para a página ${selectValue}`}
        css={{
          marginLeft: '8px',
        }}
      >
        Ir à página
      </Button>
    </Styled.Form>
  );
};

export default PageSelector;
